export { default } from './FullPageLoading'